import cx from "clsx";
import React from "react";
import { SocialMediaIcons } from "../../../components/common";
import LinkNoStyle from "../../../components/common/LinkNoStyle/LinkNoStyle";

import { DataLayerWrapper } from "../../../components/DataLayerWrapper/DataLayerWrapper";
import { isSpecificSite } from "../../../utils/isSpecificSite";
import * as styles from "./Footer.module.scss";
export interface FooterProps {
	footerLinks?: DogsTrust.Link[];
}
export const Footer: React.FC<FooterProps> = ({ footerLinks = [] }) => {
	isSpecificSite("ie", "Footer");
	return (
		<div className={styles.footerwrapper}>
			<div className={styles.footercomponent}>
				<div className={styles.footertop}>
					<div className={styles.usefullinkswrapper}>
						<h2 className={styles.usefullinkstitle}>Useful links</h2>
						<div className={styles.links}>
							{footerLinks.map((link) => (
								<DataLayerWrapper
									key={link.title}
									event={"menu_navigation"}
									menu_level={"footer"}
									menu_clicked={link.title}
									menu_url={link.url}
								>
									<LinkNoStyle
										key={link.title}
										className={styles.link}
										to={link.url}
									>
										{link.title}
									</LinkNoStyle>
								</DataLayerWrapper>
							))}
						</div>
					</div>
				</div>
				<div className={styles.sectionbreakmiddle} />
				<div className={styles.footerbottom}>
					<div className={styles.socialmediawrapper}>
						<SocialMediaIcons
							xUrl="https://twitter.com/dogstrust_ie"
							facebookUrl="https://www.facebook.com/dogstrustirelandonline"
							instagramUrl="https://www.instagram.com/dogstrust_ire"
							youtubeUrl="https://www.youtube.com/user/dogstrustireland"
							tikTokUrl="https://www.tiktok.com/@dogstrust_ireland?lang-en"
							linkedInUrl="https://ie.linkedin.com/company/dogs-trust-ireland"
						/>
					</div>
					<div className={styles.sectionbreakbottom} />
					<div className={styles.bottomwrapper}>
						<div className={styles.legalwrapper}>
							<h3 className={styles.legalwrapperheader}>
								© {new Date().getFullYear()} Dogs Trust
							</h3>
							<p className={styles.legalwrapperp}>
								Registered Charity Number: 20057978 Dogs Trust Ireland, company
								limited by Guarantee. Registered in Dublin, Ireland under
								company no. 396919. Reg Office: Ashbourne Road, Finglas, Dublin
								11.
							</p>
						</div>
						<button
							type="button"
							id="ot-sdk-btn"
							className={cx(styles.cookiebutton, "ot-sdk-show-settings")}
						>
							Cookie Settings
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer;
